import React from 'react'
import taskOne from '../Images/tasksIcon.svg'
import mercyInstr from '../Images/back3.jpg'
import instPl from '../Images/sampleprofile.jpg'

function AssTasksComp() {
  return (
    <div className='assTasksComp'>
        <h5>Assigned Tasks</h5>

        <div className='assContainer'>
            <div className='assTop'>

                <div className='taskCont1'>
                    <img src={taskOne} alt=""/>
                    <div>
                        <h3>0</h3>
                        <p>Assigned Tasks</p>
                    </div>
                </div>
                <div className='taskCont2'>
                    <img src={taskOne} alt=""/>
                    <div>
                        <h3>0</h3>
                        <p>Submitted Tasks</p>
                    </div>
                </div>
                <div className='taskCont3'>
                    <img src={taskOne} alt=""/>
                    <div>
                        <h3>0</h3>
                        <p>Reviewed Tasks</p>
                    </div>
                </div>

            </div>

            <div className='theAssMainCont'>


                <div className='taskItemsCont'>
                    <h6>My Assignments</h6>

                </div>

            </div>
        </div>
    </div>
  )
}

export default AssTasksComp